/*eslint-disable*/
import React from "react";
import {
  makeStyles,
  Paper,
  Typography,
  Chip,
  Divider,
  Button,
  Avatar,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import BookIcon from "@material-ui/icons/Book";
import HistoryIcon from "@material-ui/icons/History";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  page: { padding: theme.spacing(4) },
  card: {
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: theme.shadows[3],
    maxWidth: 1100,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  chip: { fontWeight: 600 },
  stepRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2.2),
  },
  avatar: { width: 44, height: 44, fontWeight: 700 },
  stepTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionBtn: { textTransform: "none", minWidth: 84 },
  featureCard: {
    height: "100%",
    borderRadius: 12,
    boxShadow: theme.shadows[2],
  },
  featureIcon: {
    fontSize: 28,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
}));

function Step({ index, title, desc, to }) {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div className={classes.stepRow}>
      <Avatar style={{ backgroundColor: "#059669" }} className={classes.avatar}>
        {index}
      </Avatar>

      <div style={{ flex: 1 }}>
        <div className={classes.stepTitleRow}>
          <Typography variant="subtitle1">{title}</Typography>
          {to ? (
            <Button
              size="small"
              variant="outlined"
              className={classes.actionBtn}
              onClick={() => navigate(to)}
            >
              Open
            </Button>
          ) : null}
        </div>
        <Typography variant="body2" color="textSecondary">
          {desc}
        </Typography>
      </div>
    </div>
  );
}

export default function UserJourneyPatient() {
  const classes = useStyles();
  const steps = [
    {
      title: "View & Edit Profile",
      desc: "Access and update your personal and medical information.",
      to: "/patientprofile",
    },
    {
      title: "Update Medical History",
      desc: "Add or update your medical history and preferences.",
      to: "/patientmedicalhistory",
    },
    {
      title: "Book an Appointment",
      desc: "Book a new appointment with a doctor or clinic.",
      to: "/addbookings",
    },
    {
      title: "View Pending Bookings",
      desc: "See bookings that are awaiting confirmation.",
      to: "/patientbookingoffers",
    },
    {
      title: "View Confirmed Bookings",
      desc: "See your confirmed appointments and clinic details.",
      to: "/confirmedBookings",
    },
    {
      title: "Timeline & Prescriptions",
      desc: "Track your care journey and view prescriptions issued.",
      to: "/mytimeline",
    },
  ];

  const capabilities = [
    {
      icon: <BookIcon className={classes.featureIcon} />,
      title: "Create Booking",
      desc: "Search clinics/doctors and schedule an appointment.",
    },
    {
      icon: <HistoryIcon className={classes.featureIcon} />,
      title: "Track Bookings",
      desc: "See pending and confirmed bookings and cancel if needed.",
    },
    {
      icon: <PersonIcon className={classes.featureIcon} />,
      title: "Timeline & Prescriptions",
      desc: "Review your visit history and prescribed medications.",
    },
  ];

  return (
    <div className={classes.page}>
      <Paper className={classes.card}>
        <div className={classes.header}>
          <div>
            <Typography variant="h5" gutterBottom>
              <PersonIcon style={{ verticalAlign: "middle", marginRight: 8 }} />
              Patient — Help & Quick Actions
            </Typography>
            <Typography variant="body2" color="textSecondary">
              (Patient) How to book, track and view your care
            </Typography>
          </div>
          <Chip
            label="Patient"
            className={classes.chip}
            style={{ backgroundColor: "#EEF2FF" }}
          />
        </div>

        {/* Journey Steps */}
        <div>
          {steps.map((s, i) => (
            <Step key={s.title} index={i + 1} title={s.title} desc={s.desc} to={s.to} />
          ))}
        </div>

        <Divider style={{ margin: "20px 0" }} />

        {/* Patient Capabilities */}
        <Typography variant="h6" gutterBottom>
          Key Patient Capabilities
        </Typography>
        <Grid container spacing={3}>
          {capabilities.map((f) => (
            <Grid item xs={12} sm={6} md={4} key={f.title}>
              <Card className={classes.featureCard}>
                <CardContent>
                  {f.icon}
                  <Typography variant="subtitle1" gutterBottom>
                    {f.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {f.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </div>
  );
}
